import { takeLatest, put, call } from 'redux-saga/effects';
import get from 'lodash/get';
import { getCompaniesSearchAction, getCompaniesBySlugAction, getCompaniesProductionsAction } from './actions';
// eslint-disable-next-line import/named
import { getCompanies, getProductions } from '../../utils/API';

export function* fetchCompanies({ payload }) {
  try {
    const response = yield call(getCompanies, get(payload, 'query', {}), get(payload, 'pagination', {}));
    yield put(getCompaniesSearchAction.success(get(response, 'data')));

    const ids = (response?.data?.data || []).map(item => item.id);
    const idsString = ids.join(',');
    const responseProductions = yield call(getProductions, {
      company_id: `${idsString}`,
      sort: '-year',
      approved_by: 'admin,company',
    });
    yield put(getCompaniesProductionsAction.success(get(responseProductions, 'data')));
  } catch (err) {
    yield put(getCompaniesSearchAction.failure(err.message));
    yield put(getCompaniesProductionsAction.failure(err.message));
  } finally {
    yield put(getCompaniesSearchAction.fulfill());
    yield put(getCompaniesProductionsAction.fulfill());
  }
}

export function* fetchCompaniesBySlug({ payload }) {
  try {
    const response = yield call(
      getCompanies,
      {
        country_id: get(payload, 'country'),
        ...get(payload, 'query', {}),
      },
      {
        limit: 12,
        ...get(payload, 'pagination', {}),
      },
    );
    yield put(getCompaniesBySlugAction.success(get(response, 'data')));

    const ids = (response?.data?.data || []).map(item => item.id);
    const idsString = ids.join(',');
    const responseProductions = yield call(getProductions, {
      company_id: `${idsString}`,
      sort: '-year',
      approved_by: 'admin,company',
    });
    yield put(getCompaniesProductionsAction.success(get(responseProductions, 'data')));
  } catch (err) {
    yield put(getCompaniesBySlugAction.failure(err.message));
    yield put(getCompaniesProductionsAction.failure(err.message));
  } finally {
    yield put(getCompaniesBySlugAction.fulfill());
    yield put(getCompaniesProductionsAction.fulfill());
  }
}

export default function* companiesSaga() {
  yield takeLatest(getCompaniesSearchAction.TRIGGER, fetchCompanies);
  yield takeLatest(getCompaniesBySlugAction.TRIGGER, fetchCompaniesBySlug);
}
